<template>
  <t-form labelWidth="80px">
    <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm" />
    <CptDefault :attribute="attribute" :currentCpt="currentCpt" />
    <t-form-item label="多选">
      <t-switch v-model="attribute.multiple" />
    </t-form-item>
    <t-form-item label="是否缓存">
      <t-radio-group v-model="cptDataForm.isCache" size="small">
        <t-radio :value="false">开启</t-radio>
        <t-radio :value="true">关闭</t-radio>
      </t-radio-group>
    </t-form-item>
    <t-form-item label="默认查询">
      <t-radio-group v-model="attribute.noQuery" size="small">
        <t-radio :value="false">开启</t-radio>
        <t-radio :value="true">关闭</t-radio>
      </t-radio-group>
    </t-form-item>
    <CptCombinationPageBase :attribute="attribute" :currentCpt="currentCpt" :cacheComponents="cacheComponents"  />

    <e-collapse title="简洁模式">
      <t-form-item label="开启">
        <t-switch v-model="attribute.conciseMode" @change="openConciseMode" />
      </t-form-item>
      <template v-if="attribute.conciseMode">
        <t-form-item label="弹窗方向">
          <t-radio-group size="small" v-model="attribute.conciseMode_position">
            <t-radio-button value="top">上方</t-radio-button>
            <t-radio-button value="left">左侧</t-radio-button>
            <t-radio-button value="bottom">下方</t-radio-button>
            <t-radio-button value="right">右侧</t-radio-button>
          </t-radio-group>
        </t-form-item>
        <t-form-item label="图库选择">
          <div @click="showGallery" style="width: 168px; height: 160px">
            <t-image style="width: 100%;height: 100%;background: none" :src="fileUrl + attribute.conciseMode_image"
              fit="fill" />
          </div>
        </t-form-item>
        <!-- <t-form-item label="宽度">
          <t-input-number :min="1" :max="2000000" v-model="attribute.conciseImageWidth" size="small" :decimal-places="0" />
        </t-form-item>
        <t-form-item label="高度">
          <t-input-number :min="1" :max="2000000" v-model="attribute.conciseImageHeight" size="small" :decimal-places="0" />
        </t-form-item> -->
      </template>

    </e-collapse>
    <CptInputOptionBase :attribute="attribute" :currentCpt="currentCpt" @changeSize="changeSize" />
    <!-- <t-form-item label="label">
      <t-input size="small" v-model="attribute.label"/>
    </t-form-item>
    <t-form-item label="占位符">
      <t-input v-model="attribute.placeholder" size="small"/>
    </t-form-item>
    <t-form-item label="尺寸">
      <t-radio-group v-model="attribute.size">
        <t-radio-button value="small">小</t-radio-button>
        <t-radio-button value="medium">中</t-radio-button>
        <t-radio-button value="large">大</t-radio-button>
      </t-radio-group>
    </t-form-item>
    <t-form-item label="多选">
      <t-switch v-model="attribute.multiple"/> 
    </t-form-item>
          <e-collapse title="校验设置" :expand="true">
      <t-form-item label="必填标识">
        <t-switch
          size="small"
          v-model="attribute.required"
          :label="['是', '否']"
        />
      </t-form-item>
    </e-collapse> -->
    <gallery ref="gallery" @confirmCheck="confirmCheck" />
  </t-form>
</template>

<script>
import CptData from "@/components/element/options/comp/cpt-data";
import CptDefault from "@/components/element/options/comp/cpt-default";
import CptInputOptionBase from "@/components/element/options/comp/cpt-input-option-base";
import CptCombinationPageBase from "@/components/element/options/comp/cpt-combination-page-base";
import Gallery from "@/components/designer/gallery";
import { fileUrl } from '/env'
export default {
  name: "cpt-select-option",
  props: {
    attribute: Object,
    cptDataForm: Object,
    currentCpt: Object,
    cacheComponents: Array,
  },
  components: {
    CptData,
    CptDefault,
    CptInputOptionBase,
    Gallery,
    CptCombinationPageBase,
  },
  data() {
    return {
      sizeOptions: {
        small: { width: this.currentCpt.cptWidth, height: 24 },
        medium: { width: this.currentCpt.cptWidth, height: 32 },
        large: { width: this.currentCpt.cptWidth, height: 40 },
      },
      fileUrl
    };
  },
  mounted() {
  },
  methods: {
    changeSize(val) {
      const sizeAttributes = this.sizeOptions[val];
      if (sizeAttributes) {
        this.attribute.width = sizeAttributes.width;
        this.attribute.height = sizeAttributes.height;
      } else {
        console.warn(`Invalid size option: ${val}`);
      }
    },
    showGallery() {
      this.$refs.gallery.opened();
    },
    confirmCheck(fileUrl) {
      console.log(fileUrl, 'fileUrl');
      this.attribute.conciseMode_image = fileUrl
    },
    openConciseMode(checked) {
      this.currentCpt.cptWidth = checked ? 40 : 300
      this.currentCpt.cptHeight = checked ? 40 : 50
    }
  },
};
</script>

<style scoped></style>